import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.5 23.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5v0Zm0-9a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5v0Zm0-9a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5v0Zm9 18a2.249 2.249 0 1 0 0-4.498 2.249 2.249 0 0 0 0 4.498v0Zm0-9a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5v0Zm0-9a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5v0Z",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2016%2024%22%3E%3Cpath%20d%3D%22M3.5%2023.25a2.25%202.25%200%201%200%200-4.5%202.25%202.25%200%200%200%200%204.5v0Zm0-9a2.25%202.25%200%201%200%200-4.5%202.25%202.25%200%200%200%200%204.5v0Zm0-9a2.25%202.25%200%201%200%200-4.5%202.25%202.25%200%200%200%200%204.5v0Zm9%2018a2.249%202.249%200%201%200%200-4.498%202.249%202.249%200%200%200%200%204.498v0Zm0-9a2.25%202.25%200%201%200%200-4.5%202.25%202.25%200%200%200%200%204.5v0Zm0-9a2.25%202.25%200%201%200%200-4.5%202.25%202.25%200%200%200%200%204.5v0Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
